// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, node, string } from 'prop-types'
import { useModalContext } from 'components'

const ConfirmationModal = props => {
  const {
    children,
    confirmAction,
    heading,
    idRoot,
  } = props

  const { closeContextModal } = useModalContext()

  return (
    <div className={'padding-1'}>
      <h3 className={'padding-bottom-1 text-blue-dark'}>
        {heading}
      </h3>
      {children}
      <div className={'display-flex justify-content-around padding-top-1'}>
        <button
          className={'btn btn-md bg-grey-blue hover-inverse heading-font'}
          id={`${idRoot}-cancel`}
          onClick={closeContextModal}
          type={'button'}>
          {'Cancel'}
        </button>
        <button
          className={'btn btn-md bg-blue hover-inverse heading-font'}
          id={`${idRoot}-confirm`}
          onClick={confirmAction}
          type={'button'}>
          {'Confirm'}
        </button>
      </div>
    </div>
  )
}

ConfirmationModal.propTypes = {
  children: node.isRequired,
  confirmAction: func.isRequired,
  heading: string.isRequired,
  idRoot: string.isRequired,
}

export default ConfirmationModal
